/**
 * Response Handler store.
 *
 */

import { Module, VuexModule, Action, getModule, Mutation } from 'vuex-module-decorators';
import store from '@/store';

import { redirectToNotFound } from '@/router';

export const MODULE_NAME = 'responseHandler';

// scheduling for next macrotask is enough to cancel redirect
const REDIRECT_TO_NOT_FOUND_DELAY = 0;

@Module({ dynamic: true, store, name: MODULE_NAME, namespaced: true })
class ResponseHandlerModule extends VuexModule {
    isShow = false;
    message = '';
    type = '';

    redirectToNotFoundTimeout = 0;

    @Mutation
    SET_ERROR(message: string) {
        this.message = message;
    }

    @Mutation
    SET_SHOW_STATE(payload: { isShow: boolean; type: string }) {
        this.isShow = payload.isShow;
        this.type = payload.type;
    }

    @Mutation
    SET_REDIRECT_TO_NOT_FOUND_TIMEOUT(shouldRedirect: number) {
        this.redirectToNotFoundTimeout = shouldRedirect;
    }

    @Mutation
    CANCEL_REDIRECT_TO_NOT_FOUND() {
        clearTimeout(this.redirectToNotFoundTimeout);
        this.redirectToNotFoundTimeout = 0;
    }

    @Action({ rawError: true })
    showNotify(payload: { message: string; type: string }) {
        const that = this;
        this.context.commit('SET_ERROR', payload.message);
        this.context.commit('SET_SHOW_STATE', { isShow: true, type: payload.type });

        setTimeout(function() {
            that.context.dispatch('hideNotify');
        }, 4000);
    }

    @Action({ rawError: true })
    hideNotify() {
        this.context.commit('SET_ERROR', '');
        this.context.commit('SET_SHOW_STATE', { isShow: false, type: '' });
    }

    @Action({ rawError: true })
    cancelRedirectToNotFound() {
        this.context.commit('CANCEL_REDIRECT_TO_NOT_FOUND');
    }

    @Action({ rawError: true })
    scheduleRedirectToNotFound() {
        const redirectTimeout = setTimeout(() => {
            if (!this.redirectToNotFoundTimeout) {
                return
            }

            redirectToNotFound();
        }, REDIRECT_TO_NOT_FOUND_DELAY);

        this.context.commit('SET_REDIRECT_TO_NOT_FOUND_TIMEOUT', redirectTimeout);
    }
}

export default getModule(ResponseHandlerModule);
